import { combineReducers } from 'redux';
import uiReducer from './ui';
import usersReducer from './user';
import workspacesReducer from './workspace';
import entityStatesReducer from './entityStates';
import organizationsReducer from './organization';

const rootReducer = combineReducers({
  ui: uiReducer,
  userResources: usersReducer,
  workspaceResources: workspacesReducer,
  organizationResources: organizationsReducer,
  entityStates: entityStatesReducer,
});

export default rootReducer;
